import { PageProps } from '@Types/page/PageFolder';

export const generateCanonicalUrl = (router, pageProps) => {
  let canonicalUrl = '/';
  let cursorParam = '';
  if (router?.query?.cursor !== 'offset:0' && router?.query?.cursor !== undefined) {
    cursorParam = `cursor=${
      router?.query?.cursor ? encodeURIComponent(`${router?.query?.cursor}`) : encodeURIComponent('offset:0')
    }`;
  }

  switch (pageProps.pageFolder?.pageFolderType) {
    case 'frontastic/category':
      // Use the full path with main and sub categories
      canonicalUrl = pageProps.pageFolder?.dataSourceConfigurations?.[0]?.preloadedValue?.category?._url;
      if (!canonicalUrl.startsWith('/')) {
        canonicalUrl = `/${canonicalUrl}`;
      }
      // Category is paginated so we only keep cursor param and drop the rest
      if (cursorParam) {
        canonicalUrl += `?${cursorParam}`;
      }
      break;
    case 'frontastic/product-detail-page':
      const productUrl = (pageProps as PageProps)?.data?.data?.dataSources?.__master?.product?._url;
      canonicalUrl = productUrl ?? router.asPath.split('?')?.[0];
      break;
    default:
      canonicalUrl = router.asPath.split('?')?.[0];
      const urlParams = router?.query;
      if (urlParams?.query) {
        // This is a paginated page
        canonicalUrl += `?query=${encodeURIComponent(`${urlParams?.query}`)}&${cursorParam}`;
      }
  }

  // Prefer absolute URLs
  if (typeof window !== 'undefined' && window.location.origin) {
    canonicalUrl = `${window.location.origin}${canonicalUrl}`;
  }

  return canonicalUrl;
};
